export const errors = {
    required: 'Required',
    minLength: 'Minimum length ',
    maxLength: 'Sorry, that\'s too long. Enter a Name with no more than ',
    invalid: 'Sorry, that\'s an invalid entry'
};
